import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixOpenInWebIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M13.0009 3.21094H3.99696C3.4663 3.21094 2.95737 3.42174 2.58213 3.79698C2.2069 4.17221 1.99609 4.68114 1.99609 5.21181V15.2162C1.99609 15.7468 2.2069 16.2558 2.58213 16.631C2.95737 17.0062 3.4663 17.217 3.99696 17.217H20.0039C20.5346 17.217 21.0435 17.0062 21.4188 16.631C21.794 16.2558 22.0048 15.7468 22.0048 15.2162V12.2149"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.99805 21.2188H16.0015"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12 17.2188V21.2205"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.002 8.21311L22.0041 3.21094"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.002 3.21094H22.0041V8.21311"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
